module.exports = __webpack_public_path__ + "static/media/background.a8df05c3.jpeg";